import React, { forwardRef } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css'


const AppDatePicker = ({ notValidTime, placeholder, ...props }) => {
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <div onClick={onClick}>
            <input
                defaultValue={value}
                className="form-control dateInput cursor-pointer"
                // disabled
                ref={ref}
                placeholder={placeholder}
            />
        </div>
    ));
    return (
        <div >

            {
                notValidTime ? <DatePicker
                    {...props}
                    customInput={<CustomInput />}
                    strictParsing
                    dateFormat="dd/MM/yyyy"
                    isClearable
                /> : <DatePicker
                    {...props}
                    customInput={<CustomInput />}
                    strictParsing
                    isClearable
                    timeInputLabel="Time:"
                    dateFormat="dd/MM/yyyy h:mm aa"
                    showTimeInput
                />
            }

        </div>
    );

}

export default AppDatePicker;